
export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              About MIDMAS DOO BACKA TOPOLA
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              MIDMAS DOO BACKA TOPOLA is a leading software development company based in Serbia, dedicated to creating innovative applications that enhance digital security and user experience. Our mission is to provide cutting-edge solutions that protect your online privacy while delivering exceptional performance.
            </p>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              Our VPN application represents our commitment to digital security and privacy. We understand the importance of protecting your personal information in today's connected world, and we've built our VPN with the latest security technologies to ensure your data remains safe and private.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Located in Backa Topola, Serbia, we combine local expertise with global standards to deliver world-class applications. Our team of experienced developers and security experts work tirelessly to ensure that our VPN service meets the highest standards of quality and reliability.
            </p>
            <div className="flex flex-wrap gap-4">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                  <i className="ri-map-pin-line text-2xl text-blue-600"></i>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Location</p>
                  <p className="font-semibold text-gray-900">Backa Topola, Serbia</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center">
                  <i className="ri-shield-check-line text-2xl text-purple-600"></i>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Specialty</p>
                  <p className="font-semibold text-gray-900">VPN Security</p>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/2588c781ad41f7184805ac91a8a33194.jpg"
                alt="MIDMAS Office"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-gradient-to-br from-blue-600 to-purple-600 p-8 rounded-2xl shadow-xl max-w-xs">
              <p className="text-white text-lg font-semibold mb-2">Trusted Security Solutions</p>
              <p className="text-blue-100">Protecting your digital privacy with advanced VPN technology</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
